<script setup>
import { useRoute } from '@js/utils/route';
import { ref } from 'vue';

const { competitor, tenant, callback } = defineProps({
    competitor: {
        type: Object,
        required: true,
    },
    tenant: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const loading = ref(false);

function action() {
    loading.value = true;

    axios
        .post(
            route(
                'front.projectManagement.modules.postFetchCompetitorHistoryData',
                {
                    tenant: tenant.id,
                    id: competitor.id,
                },
            ),
        )
        .then(() => {
            loading.value = false;

            if (callback) {
                callback();
            }
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <slot name="button" :action="action" :loading="loading" />
</template>
